import { type UpdateResolver } from "@urql/exchange-graphcache";
import { gql } from "urql";

import {
  type DeleteMemberInput,
  type DeleteMemberPayload,
  type Maybe,
} from "@/gql/graphql";

type Args = { input: DeleteMemberInput };
type Result = Maybe<{
  deleteMember: Maybe<DeleteMemberPayload>;
}>;

const updater: UpdateResolver<Result, Args> = (result, args, cache) => {
  cache.invalidate({
    __typename: "Member",
    id: args.input.id,
  });

  if (result?.deleteMember?.member?.organizationId) {
    cache.updateQuery(
      {
        query: gql`
          query DeleteMemberUpdate($organizationId: String!) {
            organization(id: $organizationId) {
              id
              members {
                nodes {
                  id
                }
              }
            }
          }
        `,
        variables: {
          organizationId: result.deleteMember.member.organizationId,
        },
      },
      (data) => {
        if (data?.organization?.members?.nodes) {
          data.organization.members.nodes =
            data.organization.members.nodes.filter(
              (x: { id: string }) => x.id !== args.input.id,
            );
        }
        return data;
      },
    );
  }
};

export const deleteMember = updater as unknown as UpdateResolver;
